module.exports = __webpack_public_path__ + "static/media/signal.78e6d809.svg";